import { Box, FormControl, Grid, InputBase, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import PropTypes from "prop-types";
import React from "react";
import { getMobileLimitBasedOnCC, Sample } from "../../utils";
import { mobileStyles } from "./style";
import { Label } from "../label";
import { SimpleSelect } from "../simpleSelect";

const BootStrapInput = styled(InputBase)(({ theme }) => ({
  root: {
    width: "100%",
  },
  input: {
    fontSize: "0.875rem",
    position: "relative",
    width: "100%",
    marginLeft: "4px",
  },
}));

export const MobileNumberInputComponent = (props) => {
  const [selectValue, setSelectValue] = React.useState({
    mobile: props?.value?.mobile ?? "",
    mobile_code: props?.value?.mobile_code ?? "+91",
  });

  const [limits, setLimits] = React.useState(10);
  const [isvalid, setIsvalid] = React.useState(true);

  const mobileNoValidation = (limitValue = limits) => {
    let inputLengthValue = selectValue?.mobile?.length;

    if (limitValue) {
      if (limitValue === inputLengthValue) {
        setIsvalid(true);
      } else if (limitValue > inputLengthValue) {
        setIsvalid(false);
      } else {
        setIsvalid(true);
      }
    }
  };

  const handleChangeSelect = (mobile_code = {}) => {
    let newState = {
      mobile: selectValue.mobile,
      mobile_code,
    };

    setSelectValue(newState);
    props?.handleChange(newState);

    if (Object.keys(mobile_code)?.length > 0) {
      const limit = getMobileLimitBasedOnCC(mobile_code);
      setLimits(limit);
    }
  };

  const handleChange = (mobile) => {
    if (mobile?.length <= limits) {
      let newState = {
        mobile: mobile.replace(".", ""),
        mobile_code: selectValue.mobile_code,
      };

      setSelectValue(newState);
      props?.handleChange(newState);
    }
  };

  React.useEffect(() => {
    const limit = getMobileLimitBasedOnCC(props?.value?.mobile_code);
    mobileNoValidation(limit);

    // eslint-disable-next-line
  }, [selectValue]);

  React.useEffect(() => {
    if (props?.value) {
      setSelectValue({
        ...selectValue,
        mobile: props?.value?.mobile ?? "",
        mobile_code: props?.value?.mobile_code ?? "+91",
      });
    }
    // eslint-disable-next-line
  }, [props?.value]);

  React.useEffect(() => {
    if (props?.onErrorOccured) {
      props?.onErrorOccured(!isvalid);
    }

    // eslint-disable-next-line
  }, [isvalid]);

  // Determine if the input should show error border
  const showErrorBorder =
    props?.errorValidation?.error ||
    (!Boolean(selectValue?.mobile?.length) && props.isError) ||
    (isvalid === false && selectValue?.mobile?.length > 0);

  return (
    <Box sx={mobileStyles.root} noValidate>
      {/* Input Label */}
      <Label label={props?.label} isRequired={props?.isRequired} />
      <FormControl>
        <div>
          <Grid
            container
            sx={
              showErrorBorder
                ? mobileStyles.errorBorder
                : props?.isBorder
                ? mobileStyles.borderColor
                : mobileStyles.wrapper
            }
          >
            {/* Mobile No Country Code Select */}
            <Grid item xs={props?.xs ?? 3}>
              <Box
                sx={mobileStyles.numberBorder
                }
              >
                <SimpleSelect
                  className={mobileStyles.select}
                  options={Sample}
                  handleChangeSelect={handleChangeSelect}
                  value={selectValue?.mobile_code ?? null}
                  disabled={props.isReadonly || props.disabled}
                  errorValidation={props?.errorValidation}
                />
              </Box>
            </Grid>

            {/* Mobile Number Input Field */}
            <Grid item xs={8} sx={mobileStyles.input}>
              <BootStrapInput
                inputProps={{ maxLength: limits && limits }}
                type={"number"}
                autoFocus={props.autoFocus ? true : false}
                disabled={(props?.isReadonly || props?.disabled) ?? false}
                onInvalid={(e) => {
                  e.preventDefault();
                }}
                placeholder={props.placeholder}
                onChange={(e) => handleChange(e.target.value)}
                value={selectValue?.mobile}
                error={showErrorBorder}
                onKeyPress={(e) => {
                  if (e.key === "e") {
                    e.preventDefault();
                  }
                }}
              />
            </Grid>
          </Grid>
        </div>

        {/* Warning Message */}
        <Grid container direction={"row"}>
          {isvalid === false &&
            limits !== null &&
            selectValue?.mobile?.length > 0 && (
              <Grid item xs={12} sm={12} md={12}>
                <Typography variant="caption" color="error" sx={mobileStyles.limitmessage}>
                  {"Please enter " + limits + " digits"}
                </Typography>
              </Grid>
            )}

          {/* Error Message */}
          {props?.errorValidation?.error && (
            <Grid item xs={12} sm={12} md={12}>
              <Typography variant="caption" color="error">
                {props?.errorValidation?.errorMessage ?? ""}
              </Typography>
            </Grid>
          )}

          {/* Field required Message */}
          {props.isError && !Boolean(selectValue?.mobile?.length) && (
            <Typography variant={"caption"} color={"error"}>
              {props.errorMessage}
            </Typography>
          )}

          {props.error && (
            <Typography variant="caption" color="error">
              {props.helperText}
            </Typography>
          )}
        </Grid>
      </FormControl>
    </Box>
  );
};

// Specifies the required props for the component:
MobileNumberInputComponent.propTypes = {
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  isReadonly: PropTypes.bool,
  // value: PropTypes.object,
  type: PropTypes.string,
  errorValidation: PropTypes.object,
  handleChange: PropTypes.func,
  onErrorOccured: PropTypes.func,
  numbererrorBorder: PropTypes.bool,
};
MobileNumberInputComponent.defaultProps = {
  handleChange: () => {},
};
